module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "page page--spacious"
  }, [_c('div', {
    staticClass: "page__container"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "page__section"
  }, [_c('v-layout', {
    staticClass: "page__section",
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "color": "black",
      "indeterminate": ""
    }
  })], 1)], 1) : _c('div', [_c('div', {
    staticClass: "page__section"
  }, [_c('h3', {
    staticClass: "page__section--header title--general title--3"
  }, [_vm._v("Account details")]), _vm._v(" "), _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMerchantEnabled),
      expression: "isMerchantEnabled"
    }]
  }, [(_vm.firstname) ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.firstname) + " " + _vm._s(_vm.lastname) + "\n\t\t\t\t\t\t\t\t")]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\tFirstname Lastname\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.nick) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMerchantEnabled),
      expression: "isMerchantEnabled"
    }],
    staticClass: "account__flex-item--rigth",
    attrs: {
      "to": {
        name: 'account-edit-modal',
        params: {
          firstname: _vm.firstname,
          lastname: _vm.lastname,
          email: _vm.nick
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }, [_vm._v("\n\t\t\t\t\t\t\tPassword: ********\n\t\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "account__flex-item--rigth",
    attrs: {
      "to": {
        name: 'account-password-modal'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tChange Password\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), (_vm.isMerchantEnabled) ? _c('div', {
    staticClass: "page__section"
  }, [_c('h3', {
    staticClass: "page__section--header title--general title--3"
  }, [_vm._v("Payment details")]), _vm._v(" "), ((_vm.status === 'active' || _vm.status === 'in_trial' || _vm.status === 'pending') && _vm.plan.planName !== 'veteran') ? _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }, [(_vm.plan.maxDevices === '-1') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.plan.displayName) + " (unlimited devices)\n\t\t\t\t\t\t\t")]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.plan.displayName) + " (" + _vm._s(_vm.plan.maxDevices) + " devices)\n\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.showPrice) ? _c('div', [(_vm.plan.monthlyPrice) ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.plan.monthlyPrice) + "  " + _vm._s(_vm.plan.currency) + " / Month\n\t\t\t\t\t\t\t\t")]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.plan.annualPrice) + "  " + _vm._s(_vm.plan.currency) + " / Year\n\t\t\t\t\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticClass: "account__flex-item--rigth",
    attrs: {
      "align-start": "",
      "justify-space-between": "",
      "column": ""
    }
  }, [_c('a', {
    staticClass: "unmarked",
    attrs: {
      "href": "mailto:info@webkeyapp.com?subject=Cancel Subscription"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCancel Plan\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'plans'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tUpdate Plan\n\t\t\t\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.paymentMethod) ? _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.paymentMethod) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "account__flex-item--rigth",
    attrs: {
      "to": {
        name: 'account-payment-modal'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tUpdate Payment method\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.billingAddress.address) ? _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }, [(_vm.billingAddress.company) ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.billingAddress.company) + "\n\t\t\t\t\t\t\t")]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.billingAddress.firstname) + " " + _vm._s(_vm.billingAddress.lastname) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.billingAddress.address) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.billingAddress.city) + ", " + _vm._s(_vm.billingAddress.countrycode) + " " + _vm._s(_vm.billingAddress.zip) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "account__flex-item--rigth",
    attrs: {
      "align-start": "",
      "justify-space-between": "",
      "column": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'account-billing-modal',
        params: {
          credential: _vm.billingAddress
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tChange Billing details\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account-invoices-modal'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tShow Invoices\n\t\t\t\t\t\t\t")])], 1)], 1) : _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "account__flex-item--rigth",
    attrs: {
      "to": {
        name: 'account-invoices-modal'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tShow Invoices\n\t\t\t\t\t\t")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page__section"
  }, [_c('h3', {
    staticClass: "page__section--header title--general title--3"
  }, [_vm._v("Webkey API")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }, [_vm._v("\n\t\t\t\t\t\t\tFleet ID\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "account__flex-item--right"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.fleetID) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }, [_vm._v("\n\t\t\t\t\t\t\tAPI Key\n\t\t\t\t\t\t")]), _vm._v(" "), (_vm.APIKey) ? _c('span', {
    staticClass: "account__flex-item--right"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.APIKey) + "\n\t\t\t\t\t\t")]) : _c('router-link', {
    staticClass: "account__flex-item--rigth",
    attrs: {
      "to": {
        name: 'account'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showAPIKey($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tReveal\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page__section"
  }, [_c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item--left"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "account__flex-item--rigth",
    attrs: {
      "to": {
        name: 'account-about-modal'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAbout\n\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__header"
  }, [_c('h2', {
    staticClass: "page__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\tProfile\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account__flex-item"
  }, [_c('span', {
    staticClass: "account__flex-item"
  }, [_c('div', [_vm._v("\n\t\t\t\t\t\t\t\tThe Webkey API makes easy for programmers to integrate Webkey's features into other apps.\n\t\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "unmarked",
    attrs: {
      "target": "_blank",
      "href": "https://github.com/webkeydev/webkey-headless-control"
    }
  }, [_vm._v("Android example app")]), _vm._v(" "), _c('a', {
    staticClass: "unmarked",
    attrs: {
      "target": "_blank",
      "href": "https://webkeyapp.com/apidoc"
    }
  }, [_vm._v("Dashboard API docs")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70503adf","hasScoped":true}!./app/components/account/template.html
// module id = 390
// module chunks = 0